<div class="main" *ngIf="dataIsReady">
  <div class="top-view">
    <div class="search-holder" (click)="search()">
      <img class="holder-img" src="assets/blog/search-blue.svg" />
    </div>
    <div class="blog-title">تریبون</div>
    <div class="refresh-holder" (click)="refresh()">
      <img src="assets/blog/refresh-icon.svg" />
    </div>
    <!-- <div class="profile-holder" (click)="profile()">
      <img src="assets/blog/profile.svg">
    </div> -->
    <div class="notification-holder" (click)="activity()">
      <img src="assets/blog/notification.svg" />
      <div
        *ngIf="activityCount > 0 && activityCount <= 99"
        class="activity-count"
      >
        {{ activityCount }}
      </div>
      <div *ngIf="activityCount > 99" class="activity-count">99+</div>
    </div>
  </div>
  <div class="input-panel">
    <div class="profile-avatar-holder" (click)="profile(user.userName)">
      <img
        *ngIf="user.avatarPath !== ''"
        src="{{ user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      />
      <img *ngIf="user.avatarPath === ''" src="assets/blog/avatar.svg" />
    </div>
    <div class="input-text" (click)="createPost(user.userName)">
      <div>چه خبر؟…</div>
    </div>
    <div class="input-photo" (click)="createPost(user.userName)">
      <img src="assets/blog/camera.svg" />
    </div>
  </div>
  <!-- <div class="creator-holder">
    <div class="logo-holder">
      <img src={{posts[0].user.avatarPath}}>
    </div>
    <div class="creator-title">{{posts[0].user.userName}}</div>
  </div> -->
  <div
    class="mid-view"
    id="scroll_area"
    #scrollTop
    (scroll)="scroll(false, false)"
  >
    <ul style="margin: 0; padding: 0">
      <li *ngIf="posts.length === 0" style="margin-top: 16px">
        <div class="suggest-users">
          <div class="suggest-users-title">پیشنهاد برای شما</div>
          <div
            *ngIf="suggestedUsers.length < allSuggestedUsers.length"
            class="suggest-users-more"
            (click)="suggest()"
          >
            دیدن همه
          </div>
          <div class="suggest-users-holder">
            <div
              *ngFor="let suggestedUser of suggestedUsers; let last = last"
              class="suggest-users-user"
              [ngStyle]="{ 'margin-left': last ? '16px' : '0' }"
            >
              <img
                *ngIf="suggestedUser.avatarPath !== ''"
                class="suggest-user-avatar"
                src="{{ suggestedUser.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                *ngIf="suggestedUser.avatarPath === ''"
                class="suggest-user-avatar"
                src="assets/blog/avatar.svg"
              />
              <div class="suggest-user-username">
                {{ suggestedUser.userName }}
              </div>
              <div
                class="suggest-user-top"
                (click)="profile(suggestedUser.userName)"
              ></div>
              <div
                *ngIf="
                  !blogShared.followedSuggestedUsernames.includes(
                    suggestedUser.userName
                  ) &&
                  !blogShared.pendingSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-follow"
                (click)="follow(suggestedUser)"
              >
                دنبال کردن
              </div>
              <div
                *ngIf="
                  blogShared.pendingSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-follow-pending"
                (click)="unFollow(suggestedUser)"
              >
                در انتظار تایید
              </div>
              <div
                *ngIf="
                  blogShared.followedSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-following"
                (click)="unFollow(suggestedUser)"
              >
                دنبال شده
              </div>
            </div>
          </div>
        </div>
      </li>
      <li
        *ngFor="let post of posts; let i = index; let last = last"
        [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0px' }"
      >
        <app-post
          [id]="id"
          [post]="post"
          [username]="user.userName"
          [loadImage]="loadImage[i]"
          class="appPost"
        ></app-post>
        <div
          *ngIf="(i === 2 && posts.length >= 3) || (posts.length < 3 && last)"
          class="suggest-users"
        >
          <div class="suggest-users-title">پیشنهاد برای شما</div>
          <div
            *ngIf="suggestedUsers.length < allSuggestedUsers.length"
            class="suggest-users-more"
            (click)="suggest()"
          >
            دیدن همه
          </div>
          <div class="suggest-users-holder">
            <div
              *ngFor="let suggestedUser of suggestedUsers; let last = last"
              class="suggest-users-user"
              [ngStyle]="{ 'margin-left': last ? '16px' : '0' }"
            >
              <img
                *ngIf="suggestedUser.avatarPath !== '' && loadSuggestion"
                class="suggest-user-avatar"
                src="{{ suggestedUser.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                *ngIf="suggestedUser.avatarPath === '' || !loadSuggestion"
                class="suggest-user-avatar"
                src="assets/blog/avatar.svg"
              />
              <div class="suggest-user-username">
                {{ suggestedUser.userName }}
              </div>
              <div
                class="suggest-user-top"
                (click)="profile(suggestedUser.userName)"
              ></div>
              <div
                *ngIf="
                  !blogShared.followedSuggestedUsernames.includes(
                    suggestedUser.userName
                  ) &&
                  !blogShared.pendingSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-follow"
                (click)="follow(suggestedUser)"
              >
                دنبال کردن
              </div>
              <div
                *ngIf="
                  blogShared.pendingSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-follow-pending"
                (click)="unFollow(suggestedUser)"
              >
                در انتظار تایید
              </div>
              <div
                *ngIf="
                  blogShared.followedSuggestedUsernames.includes(
                    suggestedUser.userName
                  )
                "
                class="suggest-user-following"
                (click)="unFollow(suggestedUser)"
              >
                دنبال شده
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="more-posts" *ngIf="postsCount > (postsPage + 1) * postPerPage">
      <div class="more-posts-title" (click)="showMorePosts()">
        پست‌های بیشتر
      </div>
    </div>
  </div>
</div>
